import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-multimedia-manager',
  templateUrl: './multimedia-manager.component.html',
  styleUrls: ['./multimedia-manager.component.scss']
})
export class MultimediaManagerComponent implements OnInit {

  constructor() {
  }

  ngOnInit() { }

}
